import { takeLatest } from 'redux-saga/effects';
import { homePageRequestAction, homepageRequestEffect } from 'pages/home.page';

export const homePageSaga = function* () {
  yield takeLatest(homePageRequestAction().type, homepageRequestEffect);
};
